import { render, staticRenderFns } from "./FeatureIsNotAvailableMessage.vue?vue&type=template&id=e9435930"
import script from "./FeatureIsNotAvailableMessage.vue?vue&type=script&lang=js"
export * from "./FeatureIsNotAvailableMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports